import React from "react";
import { ListGroup, Table } from "react-bootstrap";

interface SoilInterpTable {
    legend: [] | null,
    data: [] | null,
    title: string
}

const SoilInterpTable = ({legend, data, title}: SoilInterpTable) => {
    return (
        <>
            <h5 className="text-base">{title}</h5>
            {data && data.length > 0 &&
                <Table size="sm" className="text-sm">
                    <thead>
                        <tr>
                        {data.slice(0, 1).map((h:any) => (
                            h.map((e: any) => (
                                <th key={e} className="text-uppercase">{e}</th>
                            ))
                        ))}
                        </tr>
                    </thead>
                    <tbody className="text-dark">
                        {data.slice(1).map((r:any) => (
                            <tr key={r}>
                                {
                                    r.map((e: any) => (
                                        <td key={e}>{e}</td>
                                    ))
                                }
                            </tr>
                        ))}
                    </tbody>
                </Table>
            }
             {legend &&
                <ListGroup>
                {legend.slice(1).map((r:any, idx:number) => (
                    <ListGroup.Item key={idx} className="p-1 px-3 text-sm text-light text-truncate" style={{backgroundColor: `${r[1]}`}}>{r[0]}</ListGroup.Item>
                ))}
                </ListGroup>
            }
        </>
    );
}

export default SoilInterpTable;